import { render } from "./TermsServiceTextContent.vue?vue&type=template&id=f0b706ce&scoped=true"
const script = {}

import "./TermsServiceTextContent.vue?vue&type=style&index=0&id=f0b706ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b706ce"]])

export default __exports__